import { render, staticRenderFns } from "./tallydetails.vue?vue&type=template&id=6c2ca53a"
import script from "./tallydetails.vue?vue&type=script&lang=js"
export * from "./tallydetails.vue?vue&type=script&lang=js"
import style0 from "./tallydetails.vue?vue&type=style&index=0&id=6c2ca53a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports